/* CommitConfigurationRenderer.js */

"use strict";
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const Textarea = require("@gluenetworks/steve_ui_core").Control.Textfield.Textarea;

/**
 *
 * @class CommitConfiguration
 *

 */
class CommitConfigurationRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = this._createRootElement();
        this._rootElem.component = this._model;

        this._cancelButton = new ButtonControl({
            label: "Close",
            darkTheme: true,
            disabled: false,
        });

        this._textArea = new Textarea({
            label: "Commit Configuration",
            darkTheme: true,
            disabled: true,
            value: "",
            resizabe: false,
        });

        this._registerListeners();
        this.render();
    }
    get rootElement() {
        return this.getRootElement();
    }
    get model() {
        return this.getModel();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _registerListeners() {
        this._cancelButton.on(
            "UserClick",
            (this._onCancelButtonClick = this._onCancelButtonClick.bind(this))
        );
    }
    _unregisterListeners() {
        this._cancelButton.removeListener("UserClick", this._onCancelButtonClick);
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    shutdown() {
        this._unregisterListeners();
        this._rootElem.remove();

        return Promise.all([this._cancelButton.shutdown(), this._textArea.shutdown()]).then(
            () => {
                this._model = undefined;
                this._cancelButton = undefined;
                this._textArea = undefined;
                this._rootElem = undefined;
            },
            (/*err*/) => {}
        );
    }

    render() {
        this._rootElem.innerHTML = "";
        const root = document.createDocumentFragment();
        const contentEl = document.createElement("div");
        contentEl.className = "commit-configuration-content";
        contentEl.appendChild(this._textArea.renderer.rootElement);
        const commitConfig = JSON.stringify(this._model._data, null, 2);
        this._textArea.setValue(commitConfig);
        const buttonContainer = document.createElement("div");
        buttonContainer.className = "button-container";
        buttonContainer.appendChild(this._cancelButton.renderer.rootElement);
        const titleComponent = document.createElement("h2");
        titleComponent.innerText = "Audit Policy Commit Details";

        root.appendChild(titleComponent);
        root.appendChild(contentEl);

        this._rootElem.appendChild(root);
        this._rootElem.appendChild(buttonContainer);
        return new Promise((resolve /*,reject*/) => {
            resolve();
        });
    }

    getRootElement() {
        return this._rootElem;
    }

    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/
    _createRootElement() {
        const rootElement = document.createElement("div");
        rootElement.classList.add("commit-configuration", "modal_feedback_container");
        rootElement.component = this._model;
        return rootElement;
    }
    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onCancelButtonClick() {
        this._model.close();
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports = CommitConfigurationRenderer;
